import React from 'react';

export default class ArticleTitle extends React.Component {

  render() {
    return this.props.hasLink ?
      <React.Fragment>
        <h2>ESF Projekt</h2>
        <p className="article_text">{this.props.article.name}</p>
      </React.Fragment> :
      <h1>{this.props.article.name}</h1>
  }
}
